import React, { useEffect, useState } from "react";
import styled from "styled-components";

const Timer = ({ timeLeft }) => {
  const color =
    timeLeft > 30 ? "#00c853" : timeLeft > 10 ? "#ff9800" : "#f44336";

  return (
    <TimerContainer>
      <Circle color={color}>
        <span>{timeLeft}s</span>
      </Circle>
    </TimerContainer>
  );
};

const TimerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Circle = styled.div`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 4px solid ${({ color }) => color};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ color }) => color};
  font-size: 18px;
  font-weight: bold;
  box-shadow: 0 0 10px ${({ color }) => color}44;
  background: rgba(0, 0, 0, 0.1);
`;

export default Timer;
